
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Fastgør',
	'find_label': 'Søg',
	'findCancelLabel': 'Annullér',
	'dataPaneLabel': 'Data',
	'sourcePaneLabel': 'Valgte kilder',
	'sourcePaneContentLabel': 'Vælg en kilde',
	'emptySourcePaneTitle': 'Vælg en kilde',
	'emptySourcePaneCaption': 'Klik på Vælg en kilde for at tilføje data, der skal bruges til at bygge et dashboard.',
	'addDataSource': 'Vælg en kilde',
	'addDataDashboardCoachMarkContents': 'Træk data fra datavinduet, og placér dem på dashboardet.',
	'addDataStoryCoachMarkContents': 'Træk data fra datavinduet, og placér dem på historien.',
	'addDataCoachMarkTitle': 'Tilføj data',
	'selectSourcesText': 'Vælg og tilføj en datakilde for at bygge din %{app}.',
	'selectSourcesLabel': 'Vælg en kilde',
	'errorSourcesTitle': 'Kan ikke indlæse datatræstruktur',
	'errorLoadingDataSources': 'Der er opstået en fejl under indlæsning af liste over datasæt',
	'errorLoadingDataTree': 'Der er opstået en fejl under indlæsning af træstrukturen',
	'dataSetPaneLastUpdated': 'Sidst opdateret: %{date}',
	'dataSourcePaneDateUnknown': 'Ukendt',
	'moreTitle': 'Mere',
	'backLabel': 'Gå tilbage',
	'addDataSourceDialogTitle': 'Vælg en kilde',
	'addDataSourceDialogButtonLabel': 'Tilføj',
	'dlg_use': 'Brug',
	'dlg_RelinkDataSourceTitle': 'Erstat datasæt "%{dataSourceName}" med ...',
	'propertiesDialogTitle': 'Egenskaber',
	'loadingMetadata': 'Indlæser metadata',
	'missingDataSetData': 'Data til dette datasæt er ikke tilgængelige. Opfrisk datasættet, eller kontakt administratoren for at få adgang til kilden.',
	'errorLoadingSource': 'Metadata for datasættet "%{sourceName}" blev ikke indlæst. Kontakt administratoren.',
	'errorMessageTitle': 'Fejl',
	'calculation_navigation_in_use': 'Hvis du sletter beregninger, filtre eller navigationsstier, bliver alle visualiseringer, der refererer til det slettede element, ugyldige. Er du sikker på, at du vil slette?',
	'delete_confirm': 'Bekræft sletning',
	'previewUnavailable': 'Databakken og de globale filtre er ikke tilgængelige for denne pakketype.',
	'contextualGridTabName': 'Visualiseringsdata',
	'DATA_TRAY_no_data_text': 'Du har ikke nogen data i øjeblikket',
	'contextualGridMenuLabel': 'Visualiseringsdatamenu',
	'contextualGridExport': 'Eksportér',
	'nullValueText': 'NULL',
	'forecastDetailsTabName': 'Statistiske prognosedetaljer',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Nøjagtighedsmåling',
	'forecastDetailsSmoothingCoefLabel': 'Parametre',
	'forecastDetailsDiagnostics': 'Fejlfinding',
	'forecastDetailsForecastLabel': 'Prognose',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Nøjagtighed i %',
	'forecastDetailsTrendLabel': 'Tendens',
	'forecastDetailsSeasonLabel': 'Sæsonudsving',
	'forecastDetailsSeasonalPeriodLabel': 'Sæsonperiode',
	'forecastDetailsAlphaLabel': 'Alpha',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Mangler antal',
	'forecastDetailsSeriesLengthLabel': 'Serielængde',
	'forecastDetailsIgnoredPeriods': 'Ignorerede perioder',
	'forecastDetailsTrendStrength': 'Tendensstyrke',
	'forecastDetailsSeasonalityStrength': 'Sæsonudsvingsstyrke',
	'forecastDetailsTimeDeltaUnit': 'Dato/klokkeslætsinterval',
	'forecastDetailsNotes': 'Noter'
});
